// inv/src/pages/solutions/accelerators-incubators/AcceleratorsIncubatorsPage.jsx
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import SeoHead from '../../../seo/seoHead';
import AcceleratorsHero from './blocks/AcceleratorsHero';
import AcceleratorsDiscoverSection from './blocks/AcceleratorsDiscoverSection';
import AcceleratorsResearchSection from './blocks/AcceleratorsResearchSection';
import SolutionDataExportSection from '../components/SolutionDataExportSection';
import { useInitialData } from '../../../components/data/DataContext';
import languages from '../../../locales/languages';

const AcceleratorsIncubatorsPage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const ssr = useInitialData() || {};

  const ssrLang = ssr.lang || null;
  const seo = ssr.seo || {};

  const firstSeg = location.pathname.split('/').filter(Boolean)[0];
  const urlLang = languages.some(l => l.code === firstSeg) ? firstSeg : 'en';
  const lng = ssrLang || urlLang || (i18n.language || 'en').split('-')[0];

  const fallbackTitle = t(
    'pageSolutions.AcceleratorsIncubators.t1',
    'Support your startups with investor intelligence and AI-powered matching'
  );
  const fallbackDescription = t(
    'pageSolutions.AcceleratorsIncubators.t2',
    'Crino helps accelerators and incubators identify relevant investors, analyse deal activity, discover comparable startups, and provide cohorts with data-driven fundraising support.'
  );

  const {
    title = fallbackTitle,
    description = fallbackDescription,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    alternates,
    jsonLd,
  } = seo;

  return (
    <>
      <SeoHead
        lang={lng}
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImage={ogImage}
        ogUrl={ogUrl}
        ogType={ogType}
        twitterCard={twitterCard}
        alternates={alternates}
        jsonLd={jsonLd}
      />

      <div className="mt-8">
        <AcceleratorsHero />
        <AcceleratorsDiscoverSection />
        <AcceleratorsResearchSection />
        <SolutionDataExportSection audience="accelerators" />
      </div>
    </>
  );
};

export default AcceleratorsIncubatorsPage;
